import { render, staticRenderFns } from "./sms_record.vue?vue&type=template&id=36724e28&scoped=true"
import script from "./sms_record.vue?vue&type=script&lang=js"
export * from "./sms_record.vue?vue&type=script&lang=js"
import style0 from "./sms_record.vue?vue&type=style&index=0&id=36724e28&prod&lang=scss&scoped=true"
import style1 from "./sms_record.vue?vue&type=style&index=1&id=36724e28&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36724e28",
  null
  
)

export default component.exports